import { DatePipe, NgIf } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-insight-websocket-window',
  templateUrl: './insight-websocket-window.component.html',
  styleUrls: ['./insight-websocket-window.component.scss'],
  imports: [NgIf, DatePipe]
})
export class InsightWebsocketWindowComponent {
  public results;

  constructor() {}
}
